// NOTE:  This file is in the common folder but is no longer used by the client platform.
//        It is still used by the advisor platform and will remain in the common folder until that
//        is no longer the case.
// eslint-disable-next-line import/no-cycle
import {unescape} from 'lodash';

export default class RiaSettings {
  // eslint-disable-next-line max-statements
  constructor() {
    this.allowRegister = null;
    this.fontSize = null;
    this.fontFamily = null;
    this.headerColor = null;
    this.loginBackground = null;
    this.disclaimer = null;
    this.sidebarColor = null;
    this.rectangleLogo = null;
    this.squareLogo = null;
    this.companyLegalName = null;
    this.favicon = null;
    this.headerFontColor = null;
    this.sidebarFontColor = null;
    this.website = null;
    this.loginLink = null;
    this.contactPage = null;
    this.headerHoverColor = null;
    this.totalPortfolioValueImage = null;
    this.goalsTotalPortfolioValueImage = null;
  }

  // eslint-disable-next-line max-statements
  loadData(payload) {
    this.allowRegister = payload.allowRegister;
    this.fontSize = payload.riaFontSize;
    this.fontFamily = payload.riaFontFamily;
    this.headerColor = payload.riaHeaderColor;
    this.loginBackground = payload.riaBgImage;
    this.disclaimer = unescape(payload.riaDisclaimer);
    this.emailDisclaimer = unescape(payload.riaEmailDisclaimer);
    this.sidebarColor = payload.riaSidebarColor;
    this.rectangleLogo = payload.riaRectangleLogo;
    this.squareLogo = payload.riaSquareLogo;
    this.favicon = payload.riaFavicon;
    this.companyLegalName = payload.companyLegalName;
    this.sidebarFontColor = payload.riaSidebarFontColor;
    this.headerFontColor = payload.riaHeaderFontColor;
    this.website = this.formatLink(payload.website);
    this.loginLink = this.formatLink(payload.loginLink);
    this.contactPage = this.formatLink(payload.contactPageLink);
    this.headerHoverColor = payload.riaHeaderHoverColor;
    this.totalPortfolioValueImage = payload.totalPortfolioValueLogo;
    this.goalsTotalPortfolioValueImage = payload.totalGoalsValueLogo;
  }

  /**
   * footer link formatter
   * @param link
   * @returns {*}
   */
  // eslint-disable-next-line class-methods-use-this
  formatLink(link) {
    if (!link) {
      return '';
    }

    if (link.includes('http')) {
      return link;
    }

    const url = new URL(window.location.href);

    const {protocol} = url;

    const newUrl = `${protocol}//${link}`;

    return newUrl;
  }
}
